var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437.02 74.9805C388.668 26.6289 324.383 0 256 0C187.617 0 123.332 26.6289 74.9805 74.9805C26.6289 123.336 0 187.621 0 256C0 324.379 26.6289 388.668 74.9805 437.02C123.332 485.371 187.621 512 256 512C324.379 512 388.664 485.371 437.02 437.02C485.371 388.668 512 324.383 512 256C512 187.621 485.371 123.336 437.02 74.9805ZM256 482C131.383 482 30 380.613 30 256C30 131.387 131.383 30.0039 256 30C380.617 30.0039 482 131.387 482 256C481.996 380.617 380.613 482 256 482Z",
    fill: "#f89846"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.166 132H396.834C415.673 132 431 147.39 431 166.306V345.694C431 364.61 415.673 380 396.834 380H115.166C96.3262 380 81 364.61 81 345.694V166.306C81 147.39 96.3274 132 115.166 132ZM375.659 160.208L256.001 255.62L136.341 160.208H375.659ZM115.166 351.79H396.834C400.181 351.79 402.906 349.055 402.906 345.693V174.503L264.734 284.674C262.178 286.715 259.087 287.734 255.999 287.734C252.911 287.734 249.822 286.714 247.265 284.674L109.094 174.503V345.693C109.094 349.055 111.819 351.79 115.166 351.79Z",
    fill: "#f89846"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.b15bd7b43730ddab495c3e5786b24ad2.svg";
export { ForwardRef as ReactComponent };